import {
  format,
  isSameYear,
  fromUnixTime,
  formatDistanceToNow,
} from 'date-fns';
import { enUS, ptBR } from 'date-fns/locale'

export default {
  methods: {
    messageStamp(time, dateFormat = 'h:mm a') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    messageTimestamp(time, dateFormat = 'MMM d, yyyy') {
      const messageTime = fromUnixTime(time);
      const now = new Date();
      const messageDate = format(messageTime, dateFormat);
      if (!isSameYear(messageTime, now)) {
        return format(messageTime, 'LLL d y, h:mm a');
      }
      return messageDate;
    },
    dynamicTime(time) {
      const unixTime = fromUnixTime(time);
      const locale = this.getCurrentLocale(); // Get user's locale from your i18n setup
      
      return formatDistanceToNow(unixTime, { 
        addSuffix: true,
        locale: locale
      });
    },
    getCurrentLocale() {
      const localeMap = {
        'en': enUS,
        'pt_BR': ptBR,
      };
      return localeMap[this.$i18n.locale] || null;
    },
    dateFormat(time, dateFormat = 'MMM d, yyyy') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    shortTimestamp(time, withAgo = false) {
      // This function takes a time string and converts it to a short time string
      // with the following format: 1m, 1h, 1d, 1mo, 1y
      // The function also takes an optional boolean parameter withAgo
      // which will add the word "ago" to the end of the time string
      const suffix = withAgo ? ' ago' : '';

      const ptBRMappings = {
        'há menos de um minuto': 'agora',
        'há 1 minuto': '1m',
        'há 1 hora': '1h', 
        'há 1 dia': '1d',
        'há 1 mês': '1m',
        'há 1 ano': '1a',
      };
    
      const enMappings = {
        'less than a minute ago': 'now',
        'a minute ago': `1m${suffix}`,
        'an hour ago': `1h${suffix}`,
        'a day ago': `1d${suffix}`,
        'a month ago': `1mo${suffix}`,
        'a year ago': `1y${suffix}`,
      };

      const timeMappings = this.$i18n.locale === 'pt_BR' ? ptBRMappings : enMappings;

      // Check if the time string is one of the specific cases
      if (timeMappings[time]) {
        return timeMappings[time];
      }
      
      // Handle Portuguese patterns
      if (this.$i18n.locale === 'pt_BR') {
        return time
          .replace(/há |cerca de |quase |/g, '')
          .replace(' minutos', 'm')
          .replace(' minuto', 'm')
          .replace(' horas', 'h')
          .replace(' hora', 'h')
          .replace(' dias', 'd')
          .replace(' dia', 'd')
          .replace(' meses', 'm')
          .replace(' mês', 'm')
          .replace(' anos', 'a')
          .replace(' ano', 'a');
      }

      // Original English conversion
      return time
        .replace(/about|over|almost|/g, '')
        .replace(' minute ago', `m${suffix}`)
        .replace(' minutes ago', `m${suffix}`)
        .replace(' hour ago', `h${suffix}`)
        .replace(' hours ago', `h${suffix}`)
        .replace(' day ago', `d${suffix}`)
        .replace(' days ago', `d${suffix}`)
        .replace(' month ago', `mo${suffix}`)
        .replace(' months ago', `mo${suffix}`)
        .replace(' year ago', `y${suffix}`)
        .replace(' years ago', `y${suffix}`);
        },
  },
};
